import { render, staticRenderFns } from "./ResearchCategory.vue?vue&type=template&id=7368ffce"
import script from "./ResearchCategory.vue?vue&type=script&lang=js"
export * from "./ResearchCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Projects\\MDA\\schoolofmusic-ucla\\web\\app\\themes\\ucla\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7368ffce')) {
      api.createRecord('7368ffce', component.options)
    } else {
      api.reload('7368ffce', component.options)
    }
    module.hot.accept("./ResearchCategory.vue?vue&type=template&id=7368ffce", function () {
      api.rerender('7368ffce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/components/ResearchCategory.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/components/ResearchCategory.vue
// module id = 409
// module chunks = 0